import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';

import type { Action, ThunkAction } from 'types';

const RESET = 'sharedAccess/RESET';
const META_LOADED = 'sharedAccess/META_LOADED';
const SET_AS_AUTHENTICATED = 'sharedAccess/SET_AS_AUTHENTICATED';
const SET_TOKEN_INVALID = 'sharedAccess/SET_TOKEN_INVALID';

export function resetSharedAccess(): Action {
  return {
    type: RESET
  };
}

function sharedAccessSetTokenInvalid(): Action {
  return {
    type: SET_TOKEN_INVALID
  };
}

export function setAsAuthenticated(accessId: string, token: string): Action {
  return {
    type: SET_AS_AUTHENTICATED,
    payload: {
      accessId,
      token
    }
  };
}

function metaLoaded(data: any): Action {
  return {
    type: META_LOADED,
    payload: {
      data
    }
  };
}

export function sharedAccessPageFetchMeta(accessId: string, token: string): ThunkAction {
  const config = { headers: { Authorization: token } };
  const options = { suppressAuth: true };

  const url = API.END_POINTS.SHARED_ACCESS.fetchMeta(token);
  return (dispatch) => get(url, config, options)
    .then((response) => dispatch(metaLoaded(response.data)))
    .then(() => dispatch(setAsAuthenticated(accessId, token)))
    .catch(() => dispatch(sharedAccessSetTokenInvalid()));
}

const initialState = {
  isLoading: true,
  isAuthenticated: false,
  hasInvalidToken: false,
  meta: null,
  accessId: null,
  token: ''
};

export default createReducer<any, any>('sharedAccess', initialState, {
  [RESET]: () => initialState,
  [SET_TOKEN_INVALID]: (state) => ({
    ...state,
    isLoading: false,
    isAuthenticated: false,
    hasInvalidToken: true
  }),
  [SET_AS_AUTHENTICATED]: (state, { accessId, token }) => ({
    ...state,
    accessId,
    token,
    isLoading: false,
    isAuthenticated: true,
    hasInvalidToken: false
  }),
  [META_LOADED]: (state, { data }) => ({
    ...state,
    isLoading: false,
    meta: data
  })
});
